import { FOOTER } from '../types';
import { FooterObjectType, SetFooterAction } from '../../../config/interface';

export default function setFooter(footer: FooterObjectType): SetFooterAction {
  return {
    type: FOOTER,
    footer,
  };
}
